import React from 'react'
import classNames from 'classnames'

import styles from './PaginationRender.scss'
import PropTypes from 'prop-types'
import { playButtonClickSound, playHoverSound } from 'state/actions/sounds'
import { connect } from 'react-redux'

export class PaginationRender extends React.PureComponent {
    static propTypes = {
        index: PropTypes.number.isRequired,
        className: PropTypes.string,
        isSelected: PropTypes.bool,
        isLast: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
        playButtonClickSound: PropTypes.func.isRequired,
    }

    handleMouseClick = () => {
        this.props.onClick(this.props.index)
        this.props.playButtonClickSound()
    };

    handleMouseEnter = () => {
        this.props.playHoverSound()
    };

    render() {
        const { isSelected, isLast, index, className } = this.props
        const baseClassName = classNames(styles.base, {
            [styles.base__isLast]: isLast,
            [styles.base__selected]: isSelected,
        },
        className,
        )

        return (
            <div
                className={baseClassName}
                onClick={this.handleMouseClick}
                onMouseEnter={this.handleMouseEnter}
            >
                {isSelected && <span className={styles.selectedImage} />}
                {index + 1}
            </div>
        )
    }
}

const mapDispatchToProps = { playHoverSound, playButtonClickSound }

export default connect(null, mapDispatchToProps)(PaginationRender)



// WEBPACK FOOTER //
// ./components/Pagination/PaginationList/PaginationRender/PaginationRender.jsx